import React from "react";
import {PHOTO} from "../../data/siteData";
import ImageSlot from "../common/ImageSlot";
import Wave from "../common/Wave";

const AdventureBanner = () => (
    <section className="pb-banner">
        <Wave fill="#eef4fb" height={88} overTop/>
        <div style={{position: 'absolute', inset: 0}}>
            <ImageSlot src={PHOTO.banner} alt="Wide golden-hour shot of paddlers on open water"/>
        </div>
        <div className="pb-banner-scrim"/>
        <h2 className="pb-banner-title">Adventure <span className="pb-text-sun">Awaits</span> You</h2>
    </section>
);

export default AdventureBanner;
